// extracted by mini-css-extract-plugin
module.exports = {"informationBox":"style_informationBox__yQ5rn","icon":"style_icon____Db8","buttonBox":"style_buttonBox__7vk2B","linkButton":"style_linkButton__Px4Pj"};